<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Credit Card" class="d-icon d-icon--credit-card" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12"><path fill="currentColor" fill-rule="evenodd" d="M2 3a.5.5 0 0 0-.5.5v1h9v-1A.5.5 0 0 0 10 3H2Zm9.5.5A1.5 1.5 0 0 0 10 2H2A1.5 1.5 0 0 0 .5 3.5v5A1.5 1.5 0 0 0 2 10h8a1.5 1.5 0 0 0 1.5-1.5v-5Zm-1 2h-9v3A.5.5 0 0 0 2 9h8a.5.5 0 0 0 .5-.5v-3Z" clip-rule="evenodd"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconCreditCard',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: '500',
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(s),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
